import getMatches from './getMatches'
import getVinculos from './getVinculos'
import saveObsForm from './saveObsForm'

export const getMatchesService = getMatches
export const getVinculosService = getVinculos
export const saveObsFormService = saveObsForm
